export interface Bonus {
  index: string
  title: string
  body: string
  /** Portada del bonus. Si es null se muestra el carrusel de `gallery`. */
  image: string | null
  gallery?: { image: string; alt: string }[]
}

export const bonuses: Bonus[] = [
  {
    index: 'Bonus 1',
    title: '+100 Plantillas Navideñas para Pintar Esferas',
    body: 'Diseños listos para transferir y crear tus propias decoraciones.',
    image:
      'https://cdn.magicpatterns.com/uploads/hevpBycbQghCuRH9F4L3TV/MOCK_UP_PLANTILLAS.png',
  },
  {
    index: 'Bonus 2',
    title: '+100 Stickers Navideños para Decorar Esferas',
    body: 'Personajes, símbolos y diseños para personalizar tus creaciones.',
    image:
      'https://cdn.magicpatterns.com/uploads/qttMbFxg3CvHNwQKX8WYwG/MOCK_UP_STICKERS.png',
  },
  {
    index: 'Bonus 3',
    title: 'Pack de Etiquetas y Packaging Navideño',
    body: 'Todo lo necesario para presentar tus productos como un emprendimiento profesional.',
    image: null,
    gallery: [
      {
        image: 'https://cdn.magicpatterns.com/uploads/3p2AgtNpLpMyJBSc5uHeCs/2.png',
        alt: 'Hoja imprimible de etiquetas de regalo navideñas en rojo y verde',
      },
      {
        image: 'https://cdn.magicpatterns.com/uploads/mtHWqpztJPFsWNQrSwoFkX/7.png',
        alt: 'Etiquetas navideñas ilustradas con Papá Noel, árboles y regalos',
      },
      {
        image: 'https://cdn.magicpatterns.com/uploads/3nNkUXGdRpVZYu2eT73kGv/9.png',
        alt: 'Etiquetas cuadradas Feliz Navidad con fondos escoceses',
      },
      {
        image: 'https://cdn.magicpatterns.com/uploads/wwYSuwS3uLgrUyrkmp6GTC/16.png',
        alt: 'Etiquetas navideñas para escribir dedicatorias',
      },
      {
        image: 'https://cdn.magicpatterns.com/uploads/kqFLDmsNiCFxJvqebFzMQ5/21.png',
        alt: 'Etiquetas rojas Feliz Navidad con lettering dorado',
      },
    ],
  },
  {
    index: 'Bonus 4',
    title: 'Guía de Emprendimiento Navideño',
    body: 'Ideas para vender tus creaciones y aprovechar la temporada.',
    image:
      'https://cdn.magicpatterns.com/uploads/1KH5Tjjx6gfwcY1hC4z35h/GUIA_DE_EMPRENDIMIENTO.png',
  },
]
